export default "__VITE_ASSET__DsAEwVyw__"